/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.directive('informationHref', function(identity) {
	return {
		restrict: 'A',

		scope: {
			information: '='
		},

		link(scope, element, attr) {
			const {
				metas
			} = scope.information;
			if (((metas != null ? metas.type : undefined) == null)) { return; }

			const href = (() => { switch (metas.type) {
				case 'module_show':
				return `#/user/${identity.login}/elearning/${metas.session_id}`;
				case 'activity_show':
				return `#/sessions/${metas.session_id}/${metas.activity_type}/${metas.activity_id}`;
				case 'stage_show':
				return `#/sessions/${metas.session_id}/quest/${metas.activity_id}?stage=${metas.stage}`;
				case 'promo_wall_show':
				return `#/promo/${metas.promo}`;
				case 'event_subscription':
				return `#/user/${identity.login}/planning`;
			} })();

			return element.attr('href', href);
		}
	};
});
